import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { PageforbiddenComponent } from './components/pageforbidden/pageforbidden.component';
import { PagesystemerrorComponent } from './components/pagesystemerror/pagesystemerror.component';
import { TranslocoModule } from '@ngneat/transloco';

import { MenubarModule } from 'primeng/menubar';
import { QmAutoCompleteModule, QmButtonModule, QmLabelModule, QmMenubarModule, QmSidebarModule } from '@md2/md2-component-lib';


@NgModule({
  declarations: [
    HeaderComponent,
    PagenotfoundComponent,
    PageforbiddenComponent,
    PagesystemerrorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    QmSidebarModule,
    QmButtonModule,
    QmAutoCompleteModule,
    QmMenubarModule,
    QmLabelModule
  ],
  exports: [
    HeaderComponent,
    MenubarModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class TemplateModule { }
